import { INewsItemProps } from "../../components/news/NewsItem";
import { useNewsNavigation } from "../../hooks/useNewsNavigation";
import { NEWS_TIMESTAMP_PUBLISHED_AT_FIELD, NEWS_TIMESTAMP_UPDATED_AT_FIELD, NewsStory, WithID } from "../../types/db";

/** Map the story data model from the DB NewsStory to the UI props INewsItemProps */
export const mapDataToUI = (story: WithID<NewsStory, string>, { navigateToStory, language }: Pick<ReturnType<typeof useNewsNavigation>, 'navigateToStory'> & { language: string }): INewsItemProps => ({
    title: (story as any)[`title.${language}`]
        || (story as any)[`title.${language.split("-")[0]}`]
        || story.title
        || '',
    subtitle: (story as any)[`subtitle.${language}`]
        || (story as any)[`subtitle.${language.split("-")[0]}`]
        || story.subtitle
        || '',
    image: story.image || '',
    timestamp: story[NEWS_TIMESTAMP_PUBLISHED_AT_FIELD]?.toDate() || story[NEWS_TIMESTAMP_UPDATED_AT_FIELD]?.toDate() || new Date(Date.now()),
    onClick: () => navigateToStory(story.id)
})